import LayerList from "@arcgis/core/widgets/LayerList";
import Slider from "@arcgis/core/widgets/Slider";
import "@arcgis/core/assets/esri/themes/light/main.css"
import { useEffect, useRef, useState } from "react";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { table_state, addTableName } from "../../../features/table/tableSlice";
import { addQueryofTable } from "../../../features/queries/queriesSlice";

const LayersComponent = (props) => {

    const mapLayers = useRef(null);
    const [id, setId] = useState("");
    const [layer, setLayer] = useState(null);
    const [openTables, setOpenTables] = useState([])

    const dispatch = useDispatch();
    const tableState = useSelector(table_state);

    //console.log("LayersComponent mapConfig", props.mapConfig)


    const defineActions = (event) => {
        const item = event.item;

        //console.log("defineActions item", item.title)



        if (item.children.length > 1 && !item.parent && item.layer.declaredClass == "esri.layers.MapImageLayer") {
            item.actionsSections = [[
                {
                    title: i18next.t('common.tools.layers.zoom_extent'),
                    className: "esri-icon-zoom-out-fixed",
                    id: "zoom_extent"
                }/*,
                {
                    title: i18next.t('common.tools.layers.transparency'),
                    className: "esri-icon-sliders-horizontal",
                    content: slider,
                    id: "transparency"
                }*/
            ]];
        }

        if (!item.parent) {

            const slider = new Slider({
                min: 0,
                max: 1,
                precision: 2,
                values: [item.layer.opacity],
                visibleElements: {
                    labels: true,
                    rangeLabels: true
                }
            });

            slider.on("thumb-drag", (event) => {
                const { value } = event;
                item.layer.opacity = value;
            });

            item.panel = {
                content: slider,
                className: "esri-icon-sliders-horizontal",
                title: i18next.t('common.tools.layers.transparency')
            };
        }
        if (item.children.length == 0 && item.layer.declaredClass == "esri.layers.support.Sublayer") {
            item.actionsSections = [[
                {
                    title: i18next.t('common.tools.layers.add_to_table_results'),
                    className: "esri-icon-table",
                    id: "add_to_table_results"
                }
            ]];
        }
    }

    const getMapLayer = (layer) => {

        if (layer.declaredClass == "esri.layers.support.Sublayer") {
            return getMapLayer(layer.layer)
        }
        else if (layer.declaredClass == "esri.layers.MapImageLayer") {
            let out = null;
            for (let i in props.mapConfig.sgvmapMapMaplyrList) {
                let mapMaplyr = props.mapConfig.sgvmapMapMaplyrList[i].sgvmapMapLayer;
                if (mapMaplyr.name == layer.title) {
                    out = mapMaplyr;
                }
            }
            return out;
        }

    }

    const getSublayer = (mapMaplyr, id) => {
        let out = null;
        for (let i in mapMaplyr.conf.sublayers) {
            let sublayer = mapMaplyr.conf.sublayers[i];
            if (sublayer.id == id) {
                out = sublayer;
            }
        }
        return out;
    }

    useEffect(() => {
        if (mapLayers.current.innerHTML !== "") {
            mapLayers.current.removeChild(mapLayers.current.children[0])
        }
        const layerList = new LayerList({
            // executes for each ListItem in the LayerList
            listItemCreatedFunction: defineActions,
            container: mapLayers.current,
            view: props.mapView,
        });


        layerList.on("trigger-action", (event) => {
            // Capture the action id.
            const id = event.action.id;
            let layer = event.item.layer;
            setId(id)
            setLayer(layer)
            //console.log('layerList.on("trigger-action") event', event)
            if (id === "zoom_extent") {
                props.mapView.goTo(layer.fullExtent).catch((error) => {
                    if (error.name != "AbortError") {
                        console.error(error);
                    }
                });
                setId("");
                setLayer(null)
            }
            if (id === "transparency") {
                setId("");
                setLayer(null)
            }

        })

    }, [props.mapView])


    useEffect(() => {

        //Solo se ñade la tabla si anteriormente no ha sido añadida.
        if (id === "add_to_table_results") {
            let mapLayer = getMapLayer(layer);
            let sublayer = getSublayer(mapLayer, layer.id)
            //console.log('sublayer', sublayer)
            // console.log("estado", tableState)
            let table = tableState.find((tableName) => tableName == sublayer.title)

            if (!table) {
                console.log("se añade tabla")
                dispatch(addQueryofTable(""))
                props.table.addLayer(props.mapView, mapLayer, sublayer, layer)
                dispatch(addTableName(sublayer.title))
            }
            setId("");
            setLayer(null)

        }

    }, [id, layer, tableState])

    return (
        <>
            <div ref={mapLayers}></div>
        </>
    )
}
export default LayersComponent;